import { MessageSearchRequestQuery } from '@lio/api-types';

// CORRECT KEY EXAMPLE
// KEYS EXAMPLE
export const messageQueryKeys = {
  resource: 'messages' as const,
  get: (resourceId?: string) => [messageQueryKeys.resource, resourceId] as const,
  searchWithParams: (params?: MessageSearchRequestQuery) => [...messageQueryKeys.get(), params] as const,
};
